export function formatReadableDate(isoDateString) {
  const date = new Date(isoDateString)

  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2) // Adds leading 0 if needed
  const day = ('0' + date.getDate()).slice(-2) // Adds leading 0 if needed

  return `${month}/${day}/${year}`
}
